import React from 'react';

class Loading extends React.Component {
  constructor() {
    super();
    this.state = {
      slowNetwork: false,
    };
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({slowNetwork: true});
    }, 3000);
  }

  componentWillMount() {
    this.props.startLoadingBar();
  }

  componentWillUnmount() {
    this.props.stopLoadingBar();
    clearTimeout(this.timeout);
  }

  render() {
    const { slowNetwork } = this.state;
    const { hidden } = this.props;
    return (
      <div className="bg-white">
        <div className={`container ${hidden ? 'hidden' : ''}`}>
          <div className="row" style={{height: '95vh'}}>
            <div className={`col mx-auto my-5 ${!slowNetwork ? 'd-none' : ''}`} style={{maxWidth: '300px'}}>
              <div className="rounded border border-light p-5 text-secondary bg-light">
                <h3 className="mb-1">Please wait</h3>
                <p className="mb-0" style={{fontSize: '18px'}}>We are experiencing slow network</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Loading.defaultProps = {
  startLoadingBar: () => {},
  stopLoadingBar: () => {},
  hidden: false,
};

export default Loading;
